/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/no-unescaped-entities */

import React from 'react'
import style from './Terms.module.scss'

const Terms = () => (
    <div className={style.terms}>
        Member Profiles are powered by Pico.{' '}
        By Signing up, you agree to <a target="_blank" rel="noopener noreferrer" href="https://trypico.com/terms/member-agreement/">Pico's Terms</a>.
    </div>
)

export default Terms
